import { render } from "./CarritoCompras.vue?vue&type=template&id=67d185ae"
import script from "./CarritoCompras.js?vue&type=script&lang=js&external"
export * from "./CarritoCompras.js?vue&type=script&lang=js&external"

import "./CarritoCompras.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__